import { fieldOptional, fieldRequired } from "./helpers"

export const objectOptional = fieldOptional

export const objectRequired = fieldRequired
